import React from 'react';
import { Button, Paper } from '@mui/material';

interface TabsProps {
  currentTab: 'perf' | 'rh' | 'info' | 'prev';
  setCurrentTab: (t: 'perf' | 'rh' | 'info' | 'prev') => void;
}

const TabsDashboard: React.FC<TabsProps> = ({ currentTab, setCurrentTab }) => {
  const items = [
    { key: 'perf', label: 'Performances' },
    { key: 'rh', label: 'RH' },
    { key: 'prev', label: 'Prévisions' },
    { key: 'info', label: 'Informations' },
    
  ] as const;

  return (
    <Paper sx={{ display: 'inline-flex', gap: 1, p: 1}}>
        {items.map(i => {
          return (
            <Button
              key={i.key}
              onClick={() => setCurrentTab(i.key)}
              className={`px-5 py-2 rounded-full font-semibold transition-shadow inline-flex items-center justify-center`}
              variant={currentTab === i.key ? 'contained' : 'outlined'}
            >
              {i.label}
            </Button>
          );
        })}
    </Paper>
  );
};

export default TabsDashboard;